import { Subject } from "rxjs";

// creating all Subjects
const ParamSubject = new Subject();
const FullMapSubject = new Subject();
const subject = new Subject();
const TypeSubject = new Subject();
const statusSubject = new Subject();
const codeSubject = new Subject();
const contractSubject = new Subject();
// creating all methods

// map state layer service
export const dataService = {
  setData: (d: object) => subject.next(d),
  getData: () => subject.asObservable(),
};
// to get the state of the module on which we are and therefore dynamically change component
export const typeofService = {
  setType: (s: string) => TypeSubject.next(s),
  getType: () => TypeSubject.asObservable(),
};

// methods for parameters
export const dataParam = {
  newState: (d: boolean) => ParamSubject.next(d),
  getParamState: () => ParamSubject.asObservable(),
};

// methods for maps extend
export const fullMapParam={
  fullMapState:(d:boolean) => FullMapSubject.next(d),
  getFullMapState:()=> FullMapSubject.asObservable(),
}

// observer
export const closeContract = {
  setStatus:(d: boolean) => statusSubject.next(d),
  getStatus:()=> statusSubject.asObservable()
}

// for zoom install
export const codeService = {
  setData: (d: object) => codeSubject.next(d),
  getData: () => codeSubject.asObservable(),
};

// for zoom contract
export const contractService = {
  setContract: (d: string) => contractSubject.next(d),
  getContract: () => contractSubject.asObservable(),
};